<div class="slds-builder-header_container">
  <header class="slds-builder-header">
    <div class="slds-builder-header__item">
      <a routerLink="/home" class="slds-builder-header__utilities-item home-link">
        <div class="slds-builder-header__item-label slds-media slds-media_center">
          <div class="slds-media__figure">
            <span class="slds-icon_container slds-icon-utility-builder slds-current-color">
              <svg class="slds-icon slds-icon_x-small" aria-hidden="true">
                <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#builder"></use>
              </svg>
            </span>
          </div>
          <div class="slds-media__body"> {{ userName?.length ? '' + userName : '' }}</div>
        </div>
      </a>
    </div>
    <div
      class="slds-builder-header__item slds-builder-header__utilities"
      *ngIf="{ systemStatus: systemStatus$ | async } as isSystemEnabled"
    >
      <div
        routerLinkActive="active-link"
        class="slds-builder-header__utilities-item conditional-link cases-link"
        *ngIf="isLoggedIn"
      >
        <a routerLink="/home" class="slds-builder-header__item-action slds-media slds-media_center">
          <span class="slds-media__figure">
            <span class="slds-icon_container slds-icon-utility-settings slds-current-color">
              <svg class="slds-icon slds-icon_x-small" aria-hidden="true">
                <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#home"></use>
              </svg>
            </span>
          </span>
          <span class="slds-media__body">
            <span class="slds-truncate" title="Home">{{ 'breadcrumbs.home' | translate }}</span>
          </span>
        </a>
      </div>
      <div
        routerLinkActive="active-link"
        class="slds-builder-header__utilities-item conditional-link cases-link"
        *ngIf="isLoggedIn && casesBtn && isSystemEnabled.systemStatus?.enabled"
      >
        <a (click)="goToCreateCase()" class="slds-builder-header__item-action slds-media slds-media_center">
          <span class="slds-media__figure">
            <span class="slds-icon_container slds-icon-utility-settings slds-current-color">
              <svg class="slds-icon slds-icon_x-small" aria-hidden="true">
                <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#edit_form"></use>
              </svg>
            </span>
          </span>
          <span class="slds-media__body">
            <span class="slds-truncate" title="Create Case">{{ 'navbar.createCase' | translate }}</span>
          </span>
        </a>
      </div>
      <div
        routerLinkActive="active-link"
        class="slds-builder-header__utilities-item conditional-link cases-link"
        *ngIf="isLoggedIn && preferencesBtn"
      >
        <a routerLink="/preferences" class="slds-builder-header__item-action slds-media slds-media_center">
          <span class="slds-media__figure">
            <span class="slds-icon_container slds-icon-utility-settings slds-current-color">
              <svg class="slds-icon slds-icon_x-small" aria-hidden="true">
                <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#user_role"></use>
              </svg>
            </span>
          </span>
          <span class="slds-media__body">
            <span class="slds-truncate" title="Preferences">{{ 'navbar.preferences' | translate }}</span>
          </span>
        </a>
      </div>
      <div
        routerLinkActive="active-link"
        class="slds-builder-header__utilities-item conditional-link admin-link"
        *ngIf="isLoggedIn && admintBtn && isAdmin"
      >
        <a routerLink="/admin/" class="slds-builder-header__item-action slds-media slds-media_center">
          <span class="slds-media__figure">
            <span class="slds-icon_container slds-icon-utility-settings slds-current-color">
              <svg class="slds-icon slds-icon_x-small" aria-hidden="true">
                <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#settings"></use>
              </svg>
            </span>
          </span>
          <span class="slds-media__body">
            <span class="slds-truncate" title="Admin">{{ 'navbar.admin' | translate }}</span>
          </span>
        </a>
      </div>
      <div class="slds-builder-header__utilities-item" *ngIf="isLoggedIn">
        <a (click)="logout()" class="slds-builder-header__item-action slds-media slds-media_center logout-btn">
          <div class="slds-media__figure">
            <span class="slds-icon_container slds-icon-utility-help slds-current-color">
              <svg class="slds-icon slds-icon_x-small" aria-hidden="true">
                <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#logout"></use>
              </svg>
            </span>
          </div>
          <div class="slds-media__body">{{ 'navbar.logout' | translate }}</div>
        </a>
      </div>
    </div>
  </header>
</div>
